import { render } from "./AuthorizationGuest.vue?vue&type=template&id=c328d9a0&scoped=true"
import script from "./AuthorizationGuest.vue?vue&type=script&lang=js"
export * from "./AuthorizationGuest.vue?vue&type=script&lang=js"

import "./AuthorizationGuest.vue?vue&type=style&index=0&id=c328d9a0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c328d9a0"]])

export default __exports__